/**
 * Creates an initializer for adding metadata to dependency telemetry events.
 *
 * @param ai - The Application Insights client instance to attach the dependency initializer to
 * @returns A function that can be called to update the metadata
 *
 * @example
 * ```typescript
 * const ai = new ApplicationInsights();
 * const updateMetadata = createMetadataDependencyInitializer(ai);
 *
 * // Later, update metadata
 * updateMetadata({ userId: '123', environment: 'prod' });
 * ```
 */
export const createMetadataDependencyInitializer = ai => {
  let currentMetadata = {}; // initial metadata

  ai.addDependencyInitializer(envelope => {
    // eslint-disable-next-line no-param-reassign -- we need to modify the envelope
    envelope.item.properties = {
      ...envelope.item.properties,
      ...currentMetadata
    };
    return true;
  });

  // Return function to update metadata
  return newMetadata => {
    currentMetadata = newMetadata;
  };
};
//# sourceMappingURL=createMetadataDependencyInitializer.js.map